import React from 'react'
import ResourcesForm from '../forms/resources-form'
import './block-resource.sass'

const BlockResource = ({ data }) => {
  return (
    <section className={`
      BlockResource
      container-fluid
      ${data.classes ? data.classes : ''}
    `}>
      <div className="BlockResource__wrapper k-bg--grey">
        <h4 className="text-uppercase k-text--heading-linethrough">
          <span className="k-bg--grey">Free Download</span>
        </h4>
        <ResourcesForm resource={data.resource}></ResourcesForm>
      </div>
    </section>
  )
}

export default BlockResource